import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../components/layout/HeaderPortal';
import TextResourceListBrowser from './TextResourceListBrowser';
import { areas } from 'constants/areas';
import { defaultTextResource, textResourceModalVar } from '../variables';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import { IconButton } from '@totalsoft/rocket-ui';
import Portal from 'utils/portal/Portal';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_TEXT_RESOURCES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_TEXT_RESOURCES} withForbiddenPage={false}>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Add')}
            onClick={() => textResourceModalVar({ open: true, detail: defaultTextResource })}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_TEXT_RESOURCES}>
        <TextResourceListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
